export enum EStickyType {
  Simple = 'simple',
  Old = 'old',
  Modern = 'modern',
}
